let audioContextInstance: AudioContext | null = null;
let unlockRegistered = false;
let pendingPlayback = false;

const getAudioContext = () => {
  const ContextCtor =
    window.AudioContext ||
    // @ts-ignore legacy safari support
    window.webkitAudioContext;

  if (!ContextCtor) {
    return null;
  }

  if (!audioContextInstance) {
    audioContextInstance = new ContextCtor();
  }

  return audioContextInstance;
};

const triggerChime = (audioContext: AudioContext) => {
  const now = audioContext.currentTime;
  const gainNode = audioContext.createGain();
  gainNode.connect(audioContext.destination);
  gainNode.gain.setValueAtTime(0.0001, now);
  gainNode.gain.exponentialRampToValueAtTime(0.16, now + 0.02);
  gainNode.gain.exponentialRampToValueAtTime(0.0001, now + 0.42);

  const firstTone = audioContext.createOscillator();
  firstTone.type = "sine";
  firstTone.frequency.setValueAtTime(880, now);
  firstTone.frequency.exponentialRampToValueAtTime(1100, now + 0.16);
  firstTone.connect(gainNode);
  firstTone.start(now);
  firstTone.stop(now + 0.18);

  const secondTone = audioContext.createOscillator();
  secondTone.type = "triangle";
  secondTone.frequency.setValueAtTime(1320, now + 0.18);
  secondTone.frequency.exponentialRampToValueAtTime(1480, now + 0.34);
  secondTone.connect(gainNode);
  secondTone.start(now + 0.18);
  secondTone.stop(now + 0.38);
};

const resumeAudioContext = async () => {
  const audioContext = getAudioContext();
  if (!audioContext || audioContext.state === "running") {
    return audioContext;
  }

  try {
    await audioContext.resume();
  } catch (_error) {
    return audioContext;
  }

  return audioContext;
};

const registerUnlockHandlers = () => {
  if (unlockRegistered) {
    return;
  }

  unlockRegistered = true;
  const unlock = async () => {
    const audioContext = await resumeAudioContext();
    if (audioContext && audioContext.state === "running" && pendingPlayback) {
      pendingPlayback = false;
      triggerChime(audioContext);
    }

    window.removeEventListener("click", unlock);
    window.removeEventListener("keydown", unlock);
    window.removeEventListener("pointerdown", unlock);
    window.removeEventListener("touchstart", unlock);
    unlockRegistered = false;
  };

  window.addEventListener("click", unlock, { once: true });
  window.addEventListener("keydown", unlock, { once: true });
  window.addEventListener("pointerdown", unlock, { once: true });
  window.addEventListener("touchstart", unlock, { once: true });
};

export const initializeNotificationSound = () => {
  getAudioContext();
  registerUnlockHandlers();
};

export const playNotificationChime = async () => {
  const audioContext = getAudioContext();
  if (!audioContext) {
    return;
  }

  registerUnlockHandlers();
  await resumeAudioContext();

  if (audioContext.state !== "running") {
    pendingPlayback = true;
    return;
  }

  pendingPlayback = false;
  triggerChime(audioContext);
};
